(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/start-page-campaign/assets/javascripts/helpers/increment.js') >= 0) return;  svs.modules.push('/modules/start-page-campaign/assets/javascripts/helpers/increment.js');

'use strict';

function registerHelpers(hbs) {
  hbs.registerHelper('increment', value => {
    const parsedInteger = parseInt(value, 10);
    if (isNaN(parsedInteger)) {
      return value;
    }
    return parsedInteger + 1;
  });
}
if (typeof exports === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

 })(window);